import birdGif from 'data/img/bird-animation.gif';
import { Bird } from './AnimationBird.styled';

export const AnimationBird = () => {
  return <Bird src={birdGif} alt="crazy bird" />;
};
